type Data = {
  Sigla: string;
  Nome: string;
  Id: number | string;
  sigla: string;
  id_uf: number;
  nm_sexo: string;
  id_sexo: number;
  nm_orgaoexpedidor: string;
  id_oe: number;
  nm_estado_civil: string;
  id_estado_civil: number;
  nm_escolaridade: string;
  id_escolaridade: number;
  tx_escolaridade: string;
  cd_escolaridade: number;
  nm_siglagraupar: string;
  id_parentesco: number;
  id_orgao: number;
  tx_nm_orgao: string;
  Descricao: string;
  id_perfil: number;
  tx_perfil: string;
  id_fontepag: number;
  tx_nm_fonte_pag: string;
  nm_nm_contrato_s4_e: string;
  id_meiopagto_if: number;
  nm_prodcomerc: string;
  id_prodcomerc: number;
};

export const changeUF = (ufs: Data[]): void => {
  ufs.map(data => {
    data.Nome = data.sigla;
    data.Id = data.id_uf;
  });
};
export const changeUFSigla = (ufs: Data[]): void => {
  ufs.map(data => {
    data.Nome = data.sigla;
    data.Id = data.sigla;
  });
};
export const changeGender = (genders: Data[]): void => {
  genders.map(data => {
    data.Nome = data.nm_sexo;
    data.Id = data.id_sexo;
  });
};
export const changeIssuingAgency = (issuingAgencies: Data[]): void => {
  issuingAgencies.map(data => {
    data.Nome = data.nm_orgaoexpedidor;
    data.Id = data.id_oe;
  });
};
export const changePerfil = (perfis: Data[]): void => {
  perfis.map(data => {
    data.Nome = data.tx_perfil;
    data.Id = data.id_perfil;
  });
};
export const changeFontePagamento = (perfis: Data[]): void => {
  perfis.map(data => {
    data.Nome = data.tx_nm_fonte_pag;
    data.Id = data.id_fontepag;
  });
};
export const changePagamento = (perfis: Data[]): void => {
  perfis.map(data => {
    data.Nome = data.nm_nm_contrato_s4_e;
    data.Id = data.id_meiopagto_if;
  });
};
export const changeCivilStatus = (civilStatus: Data[]): void => {
  civilStatus.map(data => {
    data.Nome = data.nm_estado_civil;
    data.Id = data.id_estado_civil;
  });
};
export const changeSchooling = (schooling: Data[] = []): Data[] => {
  return schooling.map(data => {
    data.Nome =
      data.nm_escolaridade || data.tx_escolaridade || data.Descricao || '';
    data.Id = data.id_escolaridade || data.cd_escolaridade || data.Id;
    return data;
  });
};
export const changeParentage = (parentage: Data[] = []): Data[] => {
  return parentage.map(data => {
    data.Sigla = data.nm_siglagraupar;
    data.Id = data.id_parentesco;
    return data;
  });
};
export const changesubjects = (subject: Data[]): void => {
  subject.map(data => {
    data.Sigla = data.Descricao;
  });
};
export const changeParentageGDF = (parentage: Data[]): Data[] => {
  const returnData = parentage
    .filter(
      data =>
        data.id_parentesco == 10 ||
        data.id_parentesco == 11 ||
        data.id_parentesco == 14,
    )
    .map(data => {
      return {
        ...data,
        Sigla: data.id_parentesco == 14 ? 'DEPENDENTE' : data.nm_siglagraupar,
        Id: data.id_parentesco,
      };
    });
  return returnData;
};

export const changeOrgao = (orgao: Data[]): Data[] => {
  const returnData = orgao
    .filter(
      data =>
        data.id_orgao !== 93 && data.id_orgao !== 54 && data.id_orgao !== 57,
    )
    .map(data => {
      return {
        ...data,
        Nome: data.tx_nm_orgao,
        Id: data.id_orgao,
      };
    });
  return returnData;
};

export const changeProdutos = (produtos: Data[]): void => {
  produtos.map(data => {
    data.Nome = `${data.id_prodcomerc} - ${data.nm_prodcomerc}`;
    data.Id = data.id_prodcomerc;
  });
};
